module.exports = __webpack_public_path__ + "media/title_pc_1.a29bfb23.mp4";